export const rows = [
  {
    key: 'header',
    label: '  ',
  },
  {
    key: 'price',
    label: 'Price',
  },
  // {
  //   key: 'capacity',
  //   label: 'Capacity',
  //   source: 'named_tags',
  //   data_key: 'Capacity',
  //   type: 'string',
  // },
  {
    key: 'size',
    label: 'Size',
    source: 'named_tags',
    data_key: 'Size',
    type: 'string',
  },
  {
    key: 'mouth_diameter',
    label: 'Mouth Diameter',
    source: 'meta',
    data_key: 'mouth_diameter',
    type: 'string',
  },
  {
    key: 'height',
    label: 'Height',
    source: 'meta',
    data_key: 'bottle_height',
    type: 'string',
  },
  {
    key: 'base',
    label: 'Base',
    source: 'meta',
    data_key: 'bottle_base',
    type: 'string',
  },
  {
    key: 'colors',
    label: 'Colors',
  },
  {
    key: 'lid_type',
    label: 'Lid Style',
    source: 'named_tags',
    data_key: 'Lid Style',
    type: 'string',
  },
  {
    key: 'items_included',
    label: 'In the Box',
    source: 'meta',
    data_key: 'box_contents',
    type: 'string',
  },
  {
    key: 'cup_holder',
    label: 'Cup Holder Friendly',
    source: 'meta',
    data_key: 'fits_cup_holder',
    type: 'boolean',
  },
  {
    key: 'leak_proof',
    label: 'Leak-Proof Option',
    source: 'meta',
    data_key: 'leak_proof',
    type: 'boolean',
  },
];
